import { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { motion } from 'framer-motion'

import { ContentViewProps } from 'modules/trainings/components/content/types'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'

export const PageBlockView = ({ contentItem }: ContentViewProps<PageBlock>) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [isImageZoomed, setIsImageZoomed] = useState(false)

  // Close zoom on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsImageZoomed(false)
    }
    if (isImageZoomed) {
      document.addEventListener('keydown', handleEscape)
      return () => document.removeEventListener('keydown', handleEscape)
    }
  }, [isImageZoomed])

  return (
    <>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>

      {contentItem.thumbnail.url && (
        <Box
          style={{
            borderRadius: '1rem',
            overflow: 'hidden',
            aspectRatio: '16 / 9',
            backgroundColor: '#f0f0f0',
            cursor: 'pointer',
          }}
          onClick={() => setIsImageZoomed(true)}
        >
          <motion.img
            src={contentItem.thumbnail.url}
            alt={contentItem.title}
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            onLoad={() => setImageLoaded(true)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
      )}

      {contentItem.description && (
        <RichTextDisplay content={contentItem?.description || ''} format="html" />
      )}

      {/* Image zoom overlay */}
      {isImageZoomed && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(17, 17, 17, 0.72)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            cursor: 'zoom-out',
          }}
          onClick={() => setIsImageZoomed(false)}
        >
          <motion.img
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.2 }}
            src={contentItem.thumbnail.url}
            alt={contentItem.title}
            style={{
              maxWidth: '85%',
              maxHeight: '85%',
              objectFit: 'contain',
            }}
          />
        </motion.div>
      )}
    </>
  )
}
